<template>
  <div>
    <div>
      <div class="row flex-row justify-content-between mt-lg-4" style="padding-bottom: 20px; border-bottom: solid 1px rgba(223,223,223,0.37);margin-bottom: 40px">
        <div class="col-2" style="align-content: center;">
          <strong>لیست نوشته ها</strong>
        </div>
        <div class="col-2 align-content-end">
          <div class="d-flex flex-row p-2">
            <button
                color="primary"
                class="form__btn"
                square
                size="sm"
                @click="goAddNews()">
                افزودن نوشته
            </button>
          </div>
        </div>
      </div>

      <div>
        <CDataTable
            :items="items_active"
            :fields="fields"
            striped

            :items-per-page="20"
            hover
            sorter
            pagination
        >
          <template #row="{item,index}">

            <td>
              <p class="text-muted">{{ index + 1 }}</p>
            </td>

          </template>

          <template #image="{item}">
            <td>
              <img style="width: 100px;height: 60px;border-radius: 5px" v-bind:src="item.image"/>
            </td>
          </template>

          <template #date="{item}">
            <td style="text-align-last: center;font-size: 13px">
              <p class="text-muted">{{ (get_date(item.created_at)) }}</p>
            </td>
          </template>

          <template #operation="{item,index}">
            <td class="py-2 d-flex">
              <div class="edit-button mx-2 d-flex px-3">
                <i class="fi fi-rr-pencil px-1 mt-2"></i>
                <button
                    class="button-color"
                    @click="editDetails(item)"
                >ویرایش
                </button>
              </div>

              <div class="del-button mx-2 d-flex px-3">
                <i class="fi fi-rr-trash px-1 mt-2"></i>
                <button
                    class="button-color"
                    @click="delete_item(item)"
                >حذف
                </button>
              </div>

            </td>
          </template>


        </CDataTable>

      </div>

    </div>

  </div>

</template>

<script>
import axios from "axios";
import {bus} from "../../../main";
import CDataTable from "@/views/customTable/Datatable.vue";
import CButton from "@/views/CustomComponent/CButton.vue";


export default {
  name: 'BlogNewsList',
  components: {
    CButton,
    CDataTable
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {
      confirm_delete_name: new Date().getTime() + "_newslist",

      name: '',
      file: '',
      color: '',
      previewImage: '',
      description: '',
      test_sub: 'asd',
      items_active: [],
      fields: [
        {key: 'row', label: '#', _style: 'width:5%'},
        {key: 'image', label: 'تصویر', _style: 'width:10%;'},

        {key: 'post_title', label: 'عنوان', _style: 'width:20%'},
        // {key: 'user',label:'کاربر', _style: 'width:10%;'},
        {key: 'date', label: 'تاریخ', _style: 'width:10%;'},
        {key: 'views_count', label: 'نمایش', _style: 'width:5%;'},
        {key: 'operation', label: 'عملیات', _style: 'width:10%;'},

      ],
      items_deactive: [],
      items_deleted: [],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.get_news();
    // bus.$on(this.confirm_delete_name, (data) => {
    //     // alert(data);
    //     if (data=='true'){
    //         this.delete_item();
    //
    //     }else{
    //         this.status_form = 0;
    //     }
    // });
  }, watch: {},
  methods: {

    editDetails(item) {
      console.log("item edit is", item)
      this.$router.push({path: "/news/edit/" + item.id});
    },
    get_news() {
      var self = this;
      // console.log("route id "+this.$route.params.cat_id);

      axios.get('/admin/blog/get_posts', {}).then(function (response) {

        var contents = response.data;


        self.items_active = contents.posts_active.map((item, row_id) => {
          return {...item, row_id}
        })
        self.items_deactive = contents.posts_deactive.map((item, row_id) => {
          return {...item, row_id}
        })
        self.items_deleted = contents.posts_deleted.map((item, row_id) => {
          return {...item, row_id}
        })

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goRegister() {
      this.$router.push({path: 'register'});
    }, goAddNews() {

      this.$router.push({path: '/dashboard/news/add-news'});
    },
    delete_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);


      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    delete_item(item) {

      this.status_form = item.id;

      let self = this;
      const formData = new FormData()
      let url;
      url = "/admin/blog/delete_post";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        if (res.data.error == 1) {
          this.$root.modal_component.show_danger_modal('خطا', res.data.msg);

        } else {
          this.$root.modal_component.show_success_modal('تایید', res.data.msg);

        }
        self.status_form = 0;

        self.get_news();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}


</script>
